import React from "react";
import { useTranslation } from "react-i18next";
import * as styles from "./devices-toolbar.module.scss";
import IconSearch from "../../../../../dynamicicons/icon-search";
import VelavuInput from "../../../../../elements/velavu-input";
import IconClose from "../../../../../dynamicicons/icon-close";
import IconFilterList from "../../../../../dynamicicons/icon-filter-list";
import VelavuIconButton from "../../../../../elements/velavu-icon-button";
import FloorFilter from "../../../../../data/floor-filter";
import FloorFilterButton from "../../../../../elements/floor-filter-button";
import IconAdd from "../../../../../dynamicicons/icon-add";
import whitelabel from "../../../../../whitelabel";

export interface DevicesToolbarProps {
	searchText: string;
	setSearchText: (searchText: string) => void;

	levelSelection?: number;
	onChangeFloor: (filter: FloorFilter) => void;
	showFloorFilter?: boolean;

	highlightFilter: boolean;
	showFilterMenu: boolean;
	onClickShowFilterMenu: () => void;

	onClickAdd?: (
		event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
	) => void;
	addFocused?: boolean;
}

export default function DevicesToolbar(props: DevicesToolbarProps) {
	const { t } = useTranslation();
	const filterColor = props.highlightFilter
		? whitelabel.palette.primary900
		: whitelabel.palette.secondary700;

	return (
		<div className={styles.toolbar}>
			<VelavuInput
				className={styles.searchBar}
				leadingIcon={
					<IconSearch
						size={16}
						color={whitelabel.palette.secondary900}
					/>
				}
				type={"search"}
				placeholder={t("common.search")}
				value={props.searchText}
				onChange={props.setSearchText}
				fullWidth
			/>

			{props.showFloorFilter && (
				<FloorFilterButton
					selection={props.levelSelection}
					onChange={props.onChangeFloor}
				/>
			)}

			{props.onClickAdd && (
				<VelavuIconButton
					onClick={props.onClickAdd}
					focus={props.addFocused}
				>
					<IconAdd color={whitelabel.palette.secondary700} />
				</VelavuIconButton>
			)}

			<VelavuIconButton
				highlight={props.highlightFilter}
				onClick={props.onClickShowFilterMenu}
			>
				{props.showFilterMenu ? (
					<IconClose color={filterColor} />
				) : (
					<IconFilterList color={filterColor} />
				)}
			</VelavuIconButton>
		</div>
	);
}
